import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { LayoutDashboard } from 'lucide-react';

// Dashboard options mapped to roles
const DASHBOARD_OPTIONS = {
  broker: { label: 'Broker Dashboard', value: 'broker' },
  syndicator: { label: 'Syndicator Dashboard', value: 'syndicator' },
  investor: { label: 'Syndicator Dashboard', value: 'syndicator' }, // investor maps to syndicator dashboard
  iso: { label: 'ISO Dashboard', value: 'iso' },
  funder: { label: 'Funder Dashboard', value: 'funder' },
  merchant: { label: 'Merchant Dashboard', value: 'merchant' },
  underwriter: { label: 'Underwriter Dashboard', value: 'underwriter' },
};

// Roles that have distinct dashboards (excluding admin)
const DASHBOARD_ROLES = ['broker', 'syndicator', 'investor', 'iso', 'funder', 'merchant', 'underwriter'];

export const getDashboardRoles = (userRoles) => {
  if (!userRoles || !Array.isArray(userRoles)) return [];
  
  // Admin users don't use the selector
  if (userRoles.includes('admin')) return [];
  
  // Get unique dashboard types for user's roles
  const dashboardTypes = new Set();
  const availableOptions = [];
  
  userRoles.forEach(role => {
    if (DASHBOARD_OPTIONS[role]) {
      const dashValue = DASHBOARD_OPTIONS[role].value;
      if (!dashboardTypes.has(dashValue)) {
        dashboardTypes.add(dashValue);
        availableOptions.push(DASHBOARD_OPTIONS[role]);
      }
    }
  });
  
  return availableOptions;
};

export const getDefaultDashboard = (userRoles) => {
  const options = getDashboardRoles(userRoles);
  if (options.length === 0) return null;
  return options[0].value;
};

const DashboardSelector = ({ selectedDashboard, onDashboardChange, userRoles }) => {
  const options = getDashboardRoles(userRoles);
  
  // Don't render if admin or only one dashboard option
  if (options.length <= 1) return null;
  
  return (
    <div className="flex items-center gap-2">
      <LayoutDashboard className="h-4 w-4 text-slate-500" />
      <Select value={selectedDashboard} onValueChange={onDashboardChange}>
        <SelectTrigger className="w-[180px] h-9 bg-white border-slate-200">
          <SelectValue placeholder="Select Dashboard" />
        </SelectTrigger>
        <SelectContent>
          {options.map(option => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default DashboardSelector;
